// extracted by mini-css-extract-plugin
export var section = "highlight-section-module--section--f0202";
export var section_h1 = "highlight-section-module--section_h1--f9af0";
export var section_h2 = "highlight-section-module--section_h2--5926e";